import { useQuery } from "@tanstack/react-query";
import {
  EuTaxonomyCompanyActivityYearsDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EU_TAXONOMY_ACTIVITY } from "../domain";

import { euTaxonomyCompanyActivityApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_COMPANY_ACTIVITY_YEARS = "GET_COMPANY_ACTIVITY_YEARS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getCompanyActivityYears =
  async (): Promise<EuTaxonomyCompanyActivityYearsDto> => {
    const response =
      await euTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityYears();

    return response.data;
  };

export const useGetCompanyActivityYears = (
  user: UserProfileDto | null,
): {
  activityYears?: EuTaxonomyCompanyActivityYearsDto;
  activityYearsEnabled: boolean;
  isSuccessGetActivityYears: boolean;
  isLoadingGetActivityYears: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isLoading, data, isSuccess } = useQuery({
    queryKey: [DOMAIN_EU_TAXONOMY_ACTIVITY, ACTION_GET_COMPANY_ACTIVITY_YEARS],
    queryFn: () => getCompanyActivityYears(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    retry: 1,
  });

  return {
    activityYears: data,
    activityYearsEnabled: enabled,
    isSuccessGetActivityYears: isSuccess,
    isLoadingGetActivityYears: isLoading,
  };
};
